import { render, staticRenderFns } from "./AiDirectiveManager.vue?vue&type=template&id=6d4125de"
import script from "./AiDirectiveManager.vue?vue&type=script&lang=ts"
export * from "./AiDirectiveManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports